import styled from '@emotion/styled';
import React, { FC, ReactElement, ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { color, font } from 'src/shared/styles/variables';

const CardWrapper = styled.div({
    border: `2px solid ${color.catskillWhite}`,
    backgroundColor: color.white,
    boxShadow: '0px 6px 20px rgba(179, 193, 210, 0.2)',
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    borderRadius: '6px',
});

const CardContent = styled.div({
    padding: '24px 20px 20px 20px',
});

const CardImageContainer = styled.div({
    marginLeft: 'auto',
    position: 'relative',
    minWidth: '40%',
    height: '100%',
    overflow: 'hidden',
});

const Header = styled.h3(
    {
        color: color.pickledBluewood,
    },
    font.heavy(font.size.large),
);

const Content = styled.div({
    marginTop: 10,
    marginBottom: 16,
});

const ButtonStyles = {
    padding: '10px 20px',
    borderRadius: 30,
    border: 'none',
    backgroundColor: color.matteJazz,
    color: color.white,
    fontWeight: 800,
    lineHeight: '16px',
    '&:hover': {
        color: color.white,
    },
};

const StyledLink = styled(Link)(ButtonStyles);
const Button = styled.button(ButtonStyles);

interface DashboardCardProps {
    title: string;
    description: string | ReactElement;
    image: ReactNode;
    buttonText: string;
    onClick?: VoidFunction;
    to?: string;
}

export const DashboardCard: FC<DashboardCardProps> = ({
    title,
    description,
    image,
    buttonText,
    onClick,
    to,
}) => {
    const CardButton = () => {
        if (to) {
            return <StyledLink to={to}>{buttonText}</StyledLink>;
        }

        return <Button onClick={onClick}>{buttonText}</Button>;
    };

    return (
        <CardWrapper className="adminDashboardCard">
            <CardContent>
                <Header>{title}</Header>
                <Content>{description}</Content>
                <CardButton />
            </CardContent>
            <CardImageContainer>{image}</CardImageContainer>
        </CardWrapper>
    );
};
